import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.css";

const H2 = ({ children, className }) => {
  return <div className={`${style.h2} ${className}`}>{children}</div>;
};
H2.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default H2;
